<div class="form-card">
    <form class="form">
        <app-input [inputModel]="creditCard.creditCardNumber" (isInputValid)="setFormStatus($event, 'creditCardNumber')" [(value)]="creditCard.number"></app-input>
        <app-input [inputModel]="creditCard.creditCardExpirationDate" (isInputValid)="setFormStatus($event, 'creditCardDate')" [(value)]="creditCard.expirationDate"></app-input>
        <app-input [inputModel]="creditCard.creditCardCVV" (isInputValid)="setFormStatus($event, 'creditCardCVV')" [(value)]="creditCard.securityCode"></app-input>
        <app-input [inputModel]="creditCard.creditCardHolderName" (isInputValid)="setFormStatus($event, 'creditCardHolderName')" [(value)]="creditCard.name"></app-input>
        <app-input-select [children]="flags" [placeholder]="'Selecione a bandeira do cartão'" [validators]="['required']" (isInputValid)="setFormStatus($event, 'creditCardFlag')" [(value)]="creditCard.flag"></app-input-select>
    </form>
    <button (click)="registerCreditCard()" mat-raised-button class="confirma">
        Adicionar
    </button>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/credit-card-single/credit-card-single.component.html